export default (state = [], action) => (action.err ? [...state, action] : state)
